// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/evisearch/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getHealthcheck: build.query<GetHealthcheckApiResponse, GetHealthcheckApiArg>({
            query: () => ({ url: `/healthcheck` }),
        }),
        getFilters: build.query<GetFiltersApiResponse, GetFiltersApiArg>({
            query: (queryArg) => ({
                url: `/filters`,
                params: { entity: queryArg.entity },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getFilterSuggestions: build.query<GetFilterSuggestionsApiResponse, GetFilterSuggestionsApiArg>({
            query: (queryArg) => ({
                url: `/filters/${queryArg.filterId}/suggestions`,
                params: {
                    query: queryArg.query,
                    search_id: queryArg.searchId,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        search: build.mutation<SearchApiResponse, SearchApiArg>({
            query: (queryArg) => ({
                url: `/search`,
                method: "POST",
                body: queryArg.searchRequest,
                params: {
                    sort: queryArg.sort,
                    page: queryArg.page,
                    highlighterType: queryArg.highlighterType,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSearch: build.query<GetSearchApiResponse, GetSearchApiArg>({
            query: (queryArg) => ({
                url: `/search/${queryArg.searchId}`,
                params: {
                    sort: queryArg.sort,
                    page: queryArg.page,
                    filters: queryArg.filters,
                    highlighterType: queryArg.highlighterType,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        searchAfter: build.mutation<SearchAfterApiResponse, SearchAfterApiArg>({
            query: (queryArg) => ({
                url: `/search-after`,
                method: "POST",
                body: queryArg.publicSearchAfterRequest,
                params: {
                    sort: queryArg.sort,
                    page: queryArg.page,
                    highlighterType: queryArg.highlighterType,
                    count_all: queryArg.countAll,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSearchAfter: build.query<GetSearchAfterApiResponse, GetSearchAfterApiArg>({
            query: (queryArg) => ({
                url: `/search-after/${queryArg.searchId}`,
                params: {
                    sort: queryArg.sort,
                    page: queryArg.page,
                    filters: queryArg.filters,
                    highlighterType: queryArg.highlighterType,
                    count_all: queryArg.countAll,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        countSearch: build.mutation<CountSearchApiResponse, CountSearchApiArg>({
            query: (queryArg) => ({
                url: `/search/count/${queryArg.filterId}`,
                method: "POST",
                body: queryArg.searchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPositionByHandler: build.mutation<GetPositionByHandlerApiResponse, GetPositionByHandlerApiArg>({
            query: (queryArg) => ({
                url: `/position-by-handler`,
                method: "POST",
                body: queryArg.positionByHandlerRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getHandlersByPosition: build.mutation<GetHandlersByPositionApiResponse, GetHandlersByPositionApiArg>({
            query: (queryArg) => ({
                url: `/handlers-by-position`,
                method: "POST",
                body: queryArg.handlersByPositionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        validateBoolQuery: build.query<ValidateBoolQueryApiResponse, ValidateBoolQueryApiArg>({
            query: (queryArg) => ({
                url: `/validate-bool-query`,
                params: { query: queryArg.query },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        generateSearchChart: build.mutation<GenerateSearchChartApiResponse, GenerateSearchChartApiArg>({
            query: (queryArg) => ({
                url: `/search/chart/${queryArg.filterId}`,
                method: "POST",
                body: queryArg.chartRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSearchChart: build.query<GetSearchChartApiResponse, GetSearchChartApiArg>({
            query: (queryArg) => ({
                url: `/search/${queryArg.searchId}/chart/${queryArg.filterId}`,
                params: {
                    bucket_count: queryArg.bucketCount,
                    interval: queryArg.interval,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getExportOptions: build.mutation<GetExportOptionsApiResponse, GetExportOptionsApiArg>({
            query: (queryArg) => ({
                url: `/search/export-options`,
                method: "POST",
                body: queryArg.exportOptionsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSearchExportOptions: build.query<GetSearchExportOptionsApiResponse, GetSearchExportOptionsApiArg>({
            query: (queryArg) => ({
                url: `/search/export-options/${queryArg.searchId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        exportSearch: build.mutation<ExportSearchApiResponse, ExportSearchApiArg>({
            query: (queryArg) => ({
                url: `/search/export`,
                method: "POST",
                body: queryArg.exportRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        vectorSearch: build.mutation<VectorSearchApiResponse, VectorSearchApiArg>({
            query: (queryArg) => ({
                url: `/vector-search`,
                method: "POST",
                body: queryArg.vectorSearchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getVectorSearch: build.query<GetVectorSearchApiResponse, GetVectorSearchApiArg>({
            query: (queryArg) => ({
                url: `/vector-search/${queryArg.searchId}`,
                params: { k: queryArg.k },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        insertEmbeddingVectorIds: build.mutation<InsertEmbeddingVectorIdsApiResponse, InsertEmbeddingVectorIdsApiArg>({
            query: (queryArg) => ({
                url: `/embedding-vector-ids`,
                method: "POST",
                body: queryArg.embeddingVectorIdsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getEmbeddingVectorIds: build.query<GetEmbeddingVectorIdsApiResponse, GetEmbeddingVectorIdsApiArg>({
            query: (queryArg) => ({
                url: `/embedding-vector-ids/${queryArg.entityId}`,
                params: {
                    entity_type: queryArg.entityType,
                    model: queryArg.model,
                    chunking_strategy: queryArg.chunkingStrategy,
                    dimension: queryArg.dimension,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        internalSearch: build.mutation<InternalSearchApiResponse, InternalSearchApiArg>({
            query: (queryArg) => ({
                url: `/internal/search`,
                method: "POST",
                body: queryArg.internalSearchRequest,
                params: {
                    sort: queryArg.sort,
                    page: queryArg.page,
                    count_all: queryArg.countAll,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        internalCountSearch: build.mutation<InternalCountSearchApiResponse, InternalCountSearchApiArg>({
            query: (queryArg) => ({
                url: `/internal/search/count/${queryArg.filterId}`,
                method: "POST",
                body: queryArg.internalSearchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        startInternalSearchScroll: build.mutation<StartInternalSearchScrollApiResponse, StartInternalSearchScrollApiArg>({
            query: (queryArg) => ({
                url: `/internal/search-scroll`,
                method: "POST",
                body: queryArg.internalSearchRequest,
                params: { lifetime: queryArg.lifetime, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInternalSearchScroll: build.query<GetInternalSearchScrollApiResponse, GetInternalSearchScrollApiArg>({
            query: (queryArg) => ({
                url: `/internal/search-scroll/${queryArg.scrollId}`,
                params: {
                    lifetime: queryArg.lifetime,
                    entity_type: queryArg.entityType,
                    client_id: queryArg.clientId,
                    filters: queryArg.filters,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteInternalSearchScroll: build.mutation<DeleteInternalSearchScrollApiResponse, DeleteInternalSearchScrollApiArg>({
            query: (queryArg) => ({
                url: `/internal/search-scroll/${queryArg.scrollId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        internalSearchAfter: build.mutation<InternalSearchAfterApiResponse, InternalSearchAfterApiArg>({
            query: (queryArg) => ({
                url: `/internal/search-after`,
                method: "POST",
                body: queryArg.searchAfterRequest,
                params: { count_all: queryArg.countAll },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteInternalSearchAfterPit: build.mutation<DeleteInternalSearchAfterPitApiResponse, DeleteInternalSearchAfterPitApiArg>({
            query: (queryArg) => ({
                url: `/internal/search-after/pit/${queryArg.pitId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInternalFilterSuggestions: build.query<GetInternalFilterSuggestionsApiResponse, GetInternalFilterSuggestionsApiArg>({
            query: (queryArg) => ({
                url: `/internal/filters/${queryArg.filterId}/suggestions`,
                params: {
                    client_id: queryArg.clientId,
                    non_admin_user_id: queryArg.nonAdminUserId,
                    query: queryArg.query,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        triggerInternalRebuild: build.mutation<TriggerInternalRebuildApiResponse, TriggerInternalRebuildApiArg>({
            query: (queryArg) => ({
                url: `/internal/trigger-rebuild`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        internalVectorSearch: build.mutation<InternalVectorSearchApiResponse, InternalVectorSearchApiArg>({
            query: (queryArg) => ({
                url: `/internal/vector-search`,
                method: "POST",
                body: queryArg.internalVectorSearchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInternalVectorSearch: build.query<GetInternalVectorSearchApiResponse, GetInternalVectorSearchApiArg>({
            query: (queryArg) => ({
                url: `/internal/vector-search/${queryArg.searchId}`,
                params: { client_id: queryArg.clientId, k: queryArg.k },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        insertInternalEmbeddingVectorIds: build.mutation<InsertInternalEmbeddingVectorIdsApiResponse, InsertInternalEmbeddingVectorIdsApiArg>({
            query: (queryArg) => ({
                url: `/internal/embedding-vector-ids`,
                method: "POST",
                body: queryArg.embeddingVectorIdsRequest,
                params: { client_id: queryArg.clientId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInternalEmbeddingVectorIds: build.query<GetInternalEmbeddingVectorIdsApiResponse, GetInternalEmbeddingVectorIdsApiArg>({
            query: (queryArg) => ({
                url: `/internal/embedding-vector-ids/${queryArg.entityId}`,
                params: {
                    client_id: queryArg.clientId,
                    entity_type: queryArg.entityType,
                    model: queryArg.model,
                    chunking_strategy: queryArg.chunkingStrategy,
                    dimension: queryArg.dimension,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetHealthcheckApiResponse = {
    status?: string;
};
export type GetHealthcheckApiArg = void;
export type GetFiltersApiResponse = FiltersResponse;
export type GetFiltersApiArg = {
    /** Entity type to be searched */
    entity: EntityType;
};
export type GetFilterSuggestionsApiResponse = 
/** status 200 OK */ FilterSuggestionResponse;
export type GetFilterSuggestionsApiArg = {
    /** Evisearch filter ID. */
    filterId: Id;
    /** Substring to filter suggestion values by. */
    query?: string;
    /** Optional saved search ID to scope suggestions to entities matching that search. */
    searchId?: string;
    page?: {
        number?: number;
        size?: number;
    };
};
export type SearchApiResponse = SearchResponse;
export type SearchApiArg = {
    /** Filter ID used to sort results. Prefix with `-` for descending order.
      Only sortable filters are accepted.
       */
    sort?: string;
    page?: {
        size?: number;
        number?: number;
    };
    /** OpenSearch highlighter type to use for result highlighting on the `document_content` field.
      When set, matching text fragments are returned in `highlights.full_text_matches` as structured
      snippet parts with `text` and `match` types.
       */
    highlighterType?: HighlighterType;
    searchRequest: SearchRequest;
};
export type GetSearchApiResponse = SearchResponse;
export type GetSearchApiArg = {
    /** Search record ID */
    searchId: Id;
    /** Filter ID used to sort results. Prefix with `-` for descending order.
      Only sortable filters are accepted.
       */
    sort?: string;
    page?: {
        size?: number;
        number?: number;
    };
    /** Comma-separated list of filter IDs to return values for. */
    filters?: string;
    highlighterType?: HighlighterType;
};
export type SearchAfterApiResponse = 
/** status 200 OK */ PublicSearchAfterResponse;
export type SearchAfterApiArg = {
    /** Filter ID used to sort results. Prefix with `-` for descending order.
      Only sortable filters are accepted.
       */
    sort?: string;
    page?: {
        size?: number;
    };
    highlighterType?: HighlighterType;
    /** When `true` (default), sets `track_total_hits` so `meta.total` is exact even beyond
      10,000. Pass `false` to skip the extra count work when only the page of results is needed.
       */
    countAll?: boolean;
    publicSearchAfterRequest: PublicSearchAfterRequest;
};
export type GetSearchAfterApiResponse = 
/** status 200 OK */ PublicSearchAfterResponse;
export type GetSearchAfterApiArg = {
    /** Search record ID */
    searchId: Id;
    /** Filter ID used to sort results. Prefix with `-` for descending order.
      Only sortable filters are accepted.
       */
    sort?: string;
    page?: {
        size?: number;
    };
    /** Comma-separated list of filter IDs to return values for. */
    filters?: string;
    highlighterType?: HighlighterType;
    /** When `true` (default), sets `track_total_hits` so `meta.total` is exact even beyond
      10,000. Pass `false` to skip the extra count work when only the page of results is needed.
       */
    countAll?: boolean;
};
export type CountSearchApiResponse = CountResponse;
export type CountSearchApiArg = {
    /** Evisearch filter ID. */
    filterId: Id;
    searchRequest: SearchRequest;
};
export type GetPositionByHandlerApiResponse = 
/** status 200 OK */ PositionByHandlerResponse;
export type GetPositionByHandlerApiArg = {
    positionByHandlerRequest: PositionByHandlerRequest;
};
export type GetHandlersByPositionApiResponse = 
/** status 200 OK */ HandlersByPositionResponse;
export type GetHandlersByPositionApiArg = {
    handlersByPositionRequest: HandlersByPositionRequest;
};
export type ValidateBoolQueryApiResponse = 
/** status 200 Query is valid (detail is empty string) or contains a warning. */ {
    /** Empty string if valid, warning message otherwise. */
    detail?: string;
};
export type ValidateBoolQueryApiArg = {
    /** The boolean text search query string to validate. If omitted or empty, returns `{"detail": ""}`. */
    query?: string;
};
export type GenerateSearchChartApiResponse = ChartResponse;
export type GenerateSearchChartApiArg = {
    /** Evisearch filter ID. Must be a chartable filter (is_chartable: true in /filters response). */
    filterId: Id;
    chartRequest: ChartRequest;
};
export type GetSearchChartApiResponse = ChartResponse;
export type GetSearchChartApiArg = {
    /** Search record ID */
    searchId: Id;
    /** Evisearch filter ID. */
    filterId: Id;
    /** Maximum number of aggregation buckets to return. */
    bucketCount?: number;
    /** Time interval for date-based aggregations. Valid values: `DAY`, `WEEK`, `MONTH`, `QUARTER`, `YEAR`.
     */
    interval?: "DAY" | "WEEK" | "MONTH" | "QUARTER" | "YEAR";
};
export type GetExportOptionsApiResponse = 
/** status 200 OK */ ExportOptionsResponse;
export type GetExportOptionsApiArg = {
    exportOptionsRequest: ExportOptionsRequest;
};
export type GetSearchExportOptionsApiResponse = 
/** status 200 OK */ ExportOptionsResponse;
export type GetSearchExportOptionsApiArg = {
    /** Search record ID */
    searchId: Id;
};
export type ExportSearchApiResponse = Blob;
export type ExportSearchApiArg = {
    exportRequest: ExportRequest;
};
export type VectorSearchApiResponse = VectorSearchResponse;
export type VectorSearchApiArg = {
    vectorSearchRequest: VectorSearchRequest;
};
export type GetVectorSearchApiResponse = 
/** status 200 OK */ VectorSearchResponse;
export type GetVectorSearchApiArg = {
    /** Search record ID */
    searchId: Id;
    /** Number of nearest neighbors to return. */
    k?: number;
};
export type InsertEmbeddingVectorIdsApiResponse = 
/** status 200 OK -- returns the list of vector IDs that were upserted. */ EmbeddingVectorIdsResponse;
export type InsertEmbeddingVectorIdsApiArg = {
    embeddingVectorIdsRequest: EmbeddingVectorIdsRequest;
};
export type GetEmbeddingVectorIdsApiResponse = 
/** status 200 OK */ EmbeddingVectorIdsResponse;
export type GetEmbeddingVectorIdsApiArg = {
    /** Entity ID */
    entityId: Id;
    /** Entity type */
    entityType: EntityType;
    /** Embedding model name. */
    model: string;
    /** Chunking strategy identifier. */
    chunkingStrategy: string;
    /** Vector dimension matching the embedding model. */
    dimension: number;
};
export type InternalSearchApiResponse = SearchResponse;
export type InternalSearchApiArg = {
    /** Filter ID used to sort results. Prefix with `-` for descending order.
      Only sortable filters are accepted.
      Use `random` to apply OpenSearch `function_score` random ordering.
       */
    sort?: string;
    page?: {
        size?: number;
        number?: number;
    };
    /** When `true`, sets `track_total_hits: true` on the OpenSearch query so that
      `meta.total` reflects the exact document count even beyond the default 10,000 cap.
      Defaults to `false`. Use only when an accurate total is needed, as it adds query overhead.
       */
    countAll?: boolean;
    internalSearchRequest: InternalSearchRequest;
};
export type InternalCountSearchApiResponse = CountResponse;
export type InternalCountSearchApiArg = {
    /** Evisearch filter ID. */
    filterId: Id;
    internalSearchRequest: InternalSearchRequest;
};
export type StartInternalSearchScrollApiResponse = 
/** status 200 OK */ ScrollResponse;
export type StartInternalSearchScrollApiArg = {
    /** How long to keep the scroll context alive between requests.
     */
    lifetime?: "1m" | "2m" | "3m" | "4m" | "5m" | "6m" | "7m" | "8m" | "9m" | "10m";
    page?: {
        size?: number;
    };
    internalSearchRequest: InternalSearchRequest;
};
export type GetInternalSearchScrollApiResponse = 
/** status 200 OK */ ScrollResponse;
export type GetInternalSearchScrollApiArg = {
    /** Scroll session ID */
    scrollId: Id;
    /** Extends the scroll context lifetime for the next fetch.
     */
    lifetime?: "1m" | "2m" | "3m" | "4m" | "5m" | "6m" | "7m" | "8m" | "9m" | "10m";
    entityType: EntityType;
    clientId: string;
    /** Comma-separated filter IDs to return values for. */
    filters?: string;
};
export type DeleteInternalSearchScrollApiResponse = unknown;
export type DeleteInternalSearchScrollApiArg = {
    /** Scroll session ID */
    scrollId: Id;
};
export type InternalSearchAfterApiResponse = 
/** status 200 OK */ SearchAfterResponse;
export type InternalSearchAfterApiArg = {
    /** When `true`, sets `track_total_hits: true` on the OpenSearch query so that
      `meta.total` reflects the exact document count even beyond the default 10,000 cap.
      Defaults to `false`. Use only when an accurate total is needed, as it adds query overhead.
       */
    countAll?: boolean;
    searchAfterRequest: SearchAfterRequest;
};
export type DeleteInternalSearchAfterPitApiResponse = unknown;
export type DeleteInternalSearchAfterPitApiArg = {
    /** Point-in-Time context ID to delete. */
    pitId: string;
};
export type GetInternalFilterSuggestionsApiResponse = 
/** status 200 OK */ FilterSuggestionResponse;
export type GetInternalFilterSuggestionsApiArg = {
    /** Evisearch filter ID. */
    filterId: Id;
    /** The client (tenant) ID to retrieve suggestions for. */
    clientId: string;
    /** When provided, ACL filtering is applied for this user. When omitted, the request is admin-level with no ACL restrictions. */
    nonAdminUserId?: string;
    /** Substring to filter suggestion values by. */
    query?: string;
    page?: {
        number?: number;
        size?: number;
    };
};
export type TriggerInternalRebuildApiResponse = 
/** status 202 Rebuild job queued successfully. */ {
    data?: {
        type?: EntityType;
        attributes?: {
            /** AWS request ID for tracking the rebuild job. */
            job_id?: string;
            status?: string;
        };
    };
};
export type TriggerInternalRebuildApiArg = {
    body: {
        data: {
            type: EntityType;
            attributes: {
                /** If true, trigger rebuild for all clients. Mutually exclusive with `client_ids`. */
                all_clients?: boolean;
                /** List of client IDs to rebuild. Mutually exclusive with `all_clients`. */
                client_ids?: string[];
                /** Client IDs to exclude. Only applicable when `all_clients` is true. */
                exclude_client_ids?: string[];
            };
        };
    };
};
export type InternalVectorSearchApiResponse = 
/** status 200 OK */ VectorSearchResponse;
export type InternalVectorSearchApiArg = {
    internalVectorSearchRequest: InternalVectorSearchRequest;
};
export type GetInternalVectorSearchApiResponse = 
/** status 200 OK */ VectorSearchResponse;
export type GetInternalVectorSearchApiArg = {
    /** Search record ID */
    searchId: Id;
    /** Client ID that owns the saved search and vector index. */
    clientId: string;
    /** Number of nearest neighbors to return. */
    k?: number;
};
export type InsertInternalEmbeddingVectorIdsApiResponse = 
/** status 200 OK -- returns the list of vector IDs that were upserted. */ EmbeddingVectorIdsResponse;
export type InsertInternalEmbeddingVectorIdsApiArg = {
    clientId: string;
    embeddingVectorIdsRequest: EmbeddingVectorIdsRequest;
};
export type GetInternalEmbeddingVectorIdsApiResponse = 
/** status 200 OK */ EmbeddingVectorIdsResponse;
export type GetInternalEmbeddingVectorIdsApiArg = {
    /** Entity ID */
    entityId: Id;
    /** Client ID that owns the entity and vector index. */
    clientId: string;
    /** Entity type */
    entityType: EntityType;
    /** Embedding model name. */
    model: string;
    /** Chunking strategy identifier. */
    chunkingStrategy: string;
    /** Vector dimension matching the embedding model. */
    dimension: number;
};
export type FilterType = "BOOLEAN_TEXT_SEARCH" | "ARRAY_SINGLE" | "ARRAY_MULTIPLE" | "DATE" | "BOOLEAN" | "TEXT_AREA" | "STRING" | "NUMBER" | "AGE" | "ATTACHMENT" | "CLAUSE_VALUE" | "CLAUSE";
export type FilterOperator = "is_blank" | "is_not_blank" | "is_true" | "is_false" | "equals" | "not_equals" | "contains_all" | "contains_any" | "text_contains_any" | "not_contains_any" | "text_not_contains_any" | "date_before" | "date_on" | "date_after" | "date_between" | "date_in_the_last" | "date_in_the_next" | "less_than" | "less_than_equals" | "between" | "greater_than" | "greater_than_equals" | "text_contains_all_of_these_words" | "text_contains_any_of_these_words" | "text_contains_exact_phrase" | "text_not_contains_all_of_these_words" | "text_not_contains_any_of_these_words" | "text_not_contains_exact_phrase";
export type Filter = {
    /** filter */
    type?: string;
    /** id of the filter as known to evisearch */
    id?: string;
    attributes?: {
        section?: string;
        /** Display name of the filter */
        label?: string;
        /** extra information about the filter */
        help_text?: string;
        type?: FilterType;
        /** Whether this filter supports chart aggregation. */
        is_chartable?: boolean;
        /** Whether this filter can be requested as a column in results. */
        is_requestable_column?: boolean;
        /** Unified Fields client field UUID when this dynamic filter is UF-backed. Omitted for legacy Pilot-only fields. */
        uf_client_field_id?: string;
        operators?: FilterOperator[];
    };
};
export type FiltersResponse = {
    data?: Filter[];
};
export type ErrorMessage = {
    errorMessage?: string;
};
export type EntityType = "document" | "ticket" | "folder" | "document_group" | "department" | "user" | "group" | "agent_execution";
export type FilterSuggestionsMeta = {
    /** Total number of unique values as a string. When results are truncated at the cap,
      a `+` is appended (e.g. `"1000+"`). The cap is 1000 for the public endpoint and
      65535 for the internal endpoint.
       */
    select_all_count?: string;
};
export type SuggestionValue = string | number | number;
export type FilterSuggestion = {
    /** Always `"suggestion"`. */
    type?: string;
    attributes?: {
        /** Human-readable display name for the suggestion value. */
        label?: string;
        /** The raw value to use when constructing a filter query. */
        value?: SuggestionValue;
        /** Number of entities that have this value for the filter.
            Only present for dynamic select filters (SINGLE_SELECT/MULTI_SELECT);
            omitted for static filters and entity-based suggestions (folders, groups).
             */
        count?: number;
    };
};
export type FilterSuggestionResponse = {
    meta?: FilterSuggestionsMeta;
    data?: FilterSuggestion[];
};
export type Id = string;
export type MetaPage = {
    /** Page size (number of results per page). */
    size?: number;
    /** Current page number (1-indexed). */
    current?: number;
    /** Next page number, or null if this is the last page. */
    next?: number | null;
};
export type SearchMeta = {
    total?: number;
    page?: MetaPage;
};
export type SectionElement = {
    type?: string;
    value?: SearchQuery;
};
export type FilterValue = {
    value_list?: SuggestionValue[];
    /** Optional metadata for multi-select values. */
    value_meta?: {
        multi_select_data?: object;
    };
};
export type FilterElement = {
    type?: string;
    /** Filter ID in the format `{field}_{EntityType}`, e.g. `folder_Document`, `stage_Ticket`. */
    id?: Id;
    operator?: FilterOperator;
    value?: FilterValue;
};
export type QueryOperator = "AND" | "OR";
export type OperatorElement = {
    type?: string;
    value?: QueryOperator;
};
export type SearchQuery = (SectionElement | FilterElement | OperatorElement)[];
export type SelectedFieldValue = {
    /** Raw field values, or null if the field is not present on this entity. */
    value?: any[] | null;
    /** Structured objects for related-entity fields (e.g. user with name, id, email). Null for simple fields. */
    value_structured?: object[] | null;
};
export type SnippetPart = {
    /** The text content of this fragment. */
    text?: string;
    /** `text` for non-matching text, `match` for highlighted matching text. */
    type?: "text" | "match";
};
export type SearchResultItem = {
    /** Entity ID (OpenSearch document ID). */
    id?: string;
    type?: EntityType;
    /** Reserved for future use. Currently always empty `{}`. */
    permissions?: object;
    /** Map of filter ID to its value for this result. Only includes filters requested
      in the `filters` parameter of the search request.
       */
    selected_field_values?: {
        [key: string]: SelectedFieldValue;
    };
    /** Full-text match highlights (only populated when highlighterType is not `none`). */
    highlights?: {
        /** Each item is a snippet — an array of text/match parts. */
        full_text_matches?: SnippetPart[][];
    };
};
export type SearchData = {
    type?: string;
    /** SHA1 hash of the query, client, and entity type. Stable for identical searches. */
    id?: Id;
    attributes?: {
        query?: SearchQuery;
        /** Array of matching entities with requested field values and highlights. */
        results?: SearchResultItem[];
    };
};
export type SearchResponse = {
    meta?: SearchMeta;
    data?: SearchData;
    links?: {
        /** URL for the previous page, or empty string if on the first page. */
        previous?: string;
        /** URL for the next page, or empty string if on the last page. */
        next?: string;
    };
};
export type HighlighterType = "none" | "unified";
export type SearchRequestAttributes = {
    query?: SearchQuery;
    /** List of filters that should have their values returned with the matching entity. */
    filters?: Id[];
};
export type SearchRequest = {
    data?: {
        type?: EntityType;
        attributes?: SearchRequestAttributes;
    };
};
export type PublicSearchAfterResponse = {
    meta?: {
        /** Total number of matching entities. Exact (not capped at 10,000) when `count_all` is true. */
        total?: number;
        /** Cursor for the next page — pass as `search_after` in the next `POST /search-after`. Null when results are exhausted. */
        search_after?: (string | number)[] | null;
        /** Always null for this endpoint; Point-in-Time is only available on `POST /internal/search-after`. */
        pit_id?: string | null;
    };
    data?: {
        type?: string;
        /** Persisted Search record ID — reusable by `GET /search-after/{search_id}` and chart/export endpoints. */
        id?: Id;
        attributes?: {
            query?: SearchQuery;
            results?: SearchResultItem[];
        };
    };
};
export type PublicSearchAfterRequest = {
    data: {
        type: EntityType;
        attributes?: SearchRequestAttributes;
    };
    /** Cursor from the previous response's `meta.search_after`. Omit (or null) to
      fetch the first page.
       */
    search_after?: (string | number)[] | null;
    /** Number of pages to jump forward from `search_after` before returning a page.
      The server fetches `page[size] * (skip_pages + 1)` hits and returns the last
      `page[size]`. Range 0..10.
       */
    skip_pages?: number;
};
export type CountResponse = {
    data?: {
        type?: EntityType;
        /** The saved search ID associated with this count query. */
        id?: string;
        attributes?: {
            /** Number of distinct values for the specified filter across matching documents. */
            count?: number;
        };
    };
};
export type PositionByHandlerResponseData = {
    type?: string;
    attributes?: {
        /** The 0-indexed position of the handler in results, or -1 if not found */
        position?: number;
    };
};
export type PositionByHandlerMeta = {
    /** Total number of matching documents */
    total?: number;
};
export type PositionByHandlerResponse = {
    data?: PositionByHandlerResponseData;
    meta?: PositionByHandlerMeta;
};
export type PositionByHandlerRequestAttributes = {
    /** The document handler ID to search for */
    handler_id: number;
    query: SearchQuery;
    /** Sort field for ordering results (prefix with "-" for descending) */
    sort: string;
};
export type PositionByHandlerRequest = {
    data: {
        attributes: PositionByHandlerRequestAttributes;
    };
};
export type DocumentHandlerPosition = {
    type?: string;
    /** The document handler ID */
    id?: string;
    attributes?: {
        /** Document name */
        name?: string;
        /** The 0-indexed position */
        position?: number;
        /** File type extension */
        file_type?: string;
    };
};
export type HandlersByPositionResponseData = {
    type?: string;
    attributes?: {
        previous?: DocumentHandlerPosition | object;
        current?: DocumentHandlerPosition | object;
        next?: DocumentHandlerPosition | object;
    };
};
export type HandlersByPositionMeta = {
    /** Total number of matching documents */
    total?: number;
};
export type HandlersByPositionResponse = {
    data?: HandlersByPositionResponseData;
    meta?: HandlersByPositionMeta;
};
export type HandlersByPositionRequestAttributes = {
    /** The 0-indexed position in search results */
    position: number;
    query: SearchQuery;
    /** Sort field for ordering results (prefix with "-" for descending) */
    sort: string;
};
export type HandlersByPositionRequest = {
    data: {
        attributes: HandlersByPositionRequestAttributes;
    };
};
export type ChartBucket = {
    label?: string;
    value?: SuggestionValue;
    count?: number;
};
export type ChartResponse = {
    data?: {
        type?: string;
        id?: Id;
        attributes?: {
            bucket_count?: number;
            /** Number of results that did not fit into the returned buckets. */
            count_in_other?: number;
            buckets?: ChartBucket[];
        };
    };
    meta?: {
        interval_data?: {
            multiple?: number;
            interval?: "d" | "w" | "M" | "q" | "y";
        };
    };
};
export type ChartRequest = {
    data?: {
        type?: EntityType;
        attributes?: {
            query?: SearchQuery;
            /** Maximum number of aggregation buckets to return. */
            bucket_count?: number;
            /** Time interval for date-based aggregations. Maps to OpenSearch calendar intervals. */
            interval?: "DAY" | "WEEK" | "MONTH" | "QUARTER" | "YEAR";
        };
    };
};
export type ExportField = {
    id?: Id;
    label?: string;
    section?: string;
};
export type ExportOptionsResponse = {
    data?: {
        type?: string;
        attributes?: {
            fields?: ExportField[];
        };
    };
};
export type ExportOptionsRequest = {
    data?: {
        attributes?: {
            type?: EntityType;
        };
    };
};
export type ExportRequest = {
    data?: {
        attributes?: {
            type?: EntityType;
            query?: SearchQuery;
            /** List of filter IDs to include as columns in the export. */
            fields?: Id[];
        };
    };
};
export type IdsFilter = {
    /** Set to true when searching workflow documents that are not indexed in OpenSearch. */
    is_workflow_doc?: boolean;
    /** Restrict vector search results to these document IDs. */
    document_id?: string[];
};
export type VectorSearchResult = {
    /** The entity type (e.g. document_chunk_embedding). */
    type?: string;
    /** Pinecone vector ID in the format `{entity_id}#chnk_{chunk_index}`, e.g. `98765#chnk_0`. */
    id?: string;
    /** Pinecone vector metadata (e.g. document_id, chunk index). */
    metadata?: object;
    /** Cosine similarity score between 0 and 1. */
    score?: number;
    /** The vector values (usually empty unless explicitly requested). */
    values?: number[];
};
export type VectorSearchResponse = {
    data?: {
        type?: string;
        id?: Id;
        attributes?: {
            k?: number;
            vector?: number[];
            ids_filter?: IdsFilter;
            query?: SearchQuery;
            results?: VectorSearchResult[];
        };
    };
    meta?: {
        total?: number;
    };
};
export type EmbeddingStrategy = {
    /** Embedding model identifier. */
    model?: string;
    /** Chunking strategy version. */
    chunking_strategy?: string;
    /** Vector dimension matching the model. */
    dimension?: number;
};
export type VectorSearchRequest = {
    data?: {
        /** Must be `document_chunk_embedding` for vector search. */
        type?: string;
        attributes?: {
            /** The embedding vector to search with. Length must match the dimension in embedding_strategy. */
            vector?: number[];
            /** Number of nearest neighbors to return (top-k). */
            k?: number;
            /** Optional OpenSearch query to pre-filter documents before Pinecone vector search. Uses the same query format as the regular search endpoint. */
            query?: SearchQuery;
            /** Entity type for the pre-filter query (e.g. `document`). Required when `query` is non-empty. */
            query_entity?: string | null;
            ids_filter?: IdsFilter;
            embedding_strategy?: EmbeddingStrategy;
        };
    };
};
export type EmbeddingVectorIdsResponse = {
    meta?: {
        total?: number;
    };
    data?: {
        type?: string;
        id?: string;
    }[];
};
export type EmbeddingPayload = {
    /** Inline list of embedding chunks. Each object contains the vector and associated metadata. */
    chunk_list?: object[];
    /** S3 bucket name containing the embedding payload JSON. */
    bucket?: string | null;
    /** S3 object key for the embedding payload JSON. */
    key?: string | null;
};
export type EmbeddingVectorIdsRequest = {
    data?: {
        type?: EntityType;
        id?: Id;
        attributes?: {
            embedding_payload?: EmbeddingPayload;
            embedding_strategy?: EmbeddingStrategy;
        };
    };
};
export type InternalSearchRequestAttributes = {
    client_id?: string;
    /** When omitted or null, the request is treated as admin-level — no ACL filter is applied
      and all matching documents are returned regardless of user permissions.
      When provided, ACL filtering is applied so results are restricted to documents
      the specified user has access to.
       */
    non_admin_user_id?: string | null;
    query?: SearchQuery;
    filters?: Id[];
    /** Filter ID to sort by. Used by the search-after endpoint. Prefix with `-` for descending. */
    sort?: string;
    /** Number of results per page. Used by the search-after endpoint. */
    size?: number;
};
export type InternalSearchRequest = {
    data?: {
        type?: EntityType;
        attributes?: InternalSearchRequestAttributes;
    };
};
export type ScrollResponse = {
    data?: {
        type?: string;
        /** The scroll ID, same as `meta.scroll_id`. */
        id?: string;
        attributes?: {
            query?: SearchQuery;
            results?: SearchResultItem[];
        };
    };
    meta?: {
        /** Total number of matching documents. */
        total?: number;
        /** Cursor to pass to `GET /search-scroll/{scroll_id}` to fetch the next page. */
        scroll_id?: string;
    };
};
export type SearchAfterResponse = {
    meta?: {
        /** Total number of matching documents. */
        total?: number;
        /** Sort values of the last hit — pass this as `search_after` in the next request. Null when results are exhausted. */
        search_after?: (string | number)[] | null;
        /** Refreshed PIT context ID — always use the latest value from each response. Null when not using PIT. */
        pit_id?: string | null;
    };
    data?: {
        type?: string;
        attributes?: {
            query?: SearchQuery;
            results?: SearchResultItem[];
        };
    };
};
export type SearchAfterRequest = {
    data?: {
        type?: EntityType;
        attributes?: InternalSearchRequestAttributes;
    };
    /** Set to true on the first request to create a new PIT context. */
    create_pit?: boolean;
    /** PIT context ID from the previous response. */
    pit_id?: string | null;
    /** How long to extend the PIT context on each request. Only validated when using PIT (create_pit or pit_id). Defaults to 2m. */
    pit_keep_alive?: "1m" | "2m" | "3m" | "4m" | "5m" | "6m" | "7m" | "8m" | "9m" | "10m";
    /** Sort values from the last hit of the previous page — taken directly from `meta.search_after` in the previous response. */
    search_after?: (string | number)[] | null;
};
export type InternalVectorSearchRequest = {
    data?: {
        /** Must be `document_chunk_embedding` for vector search. */
        type?: string;
        attributes?: {
            /** Client ID to search within (required for internal endpoints). */
            client_id?: string;
            /** The embedding vector to search with. Length must match the dimension in embedding_strategy. */
            vector?: number[];
            /** Number of nearest neighbors to return (top-k). */
            k?: number;
            /** Optional OpenSearch query to pre-filter documents before Pinecone vector search. */
            query?: SearchQuery;
            /** Entity type for the pre-filter query (e.g. `document`). Required when `query` is non-empty. */
            query_entity?: string | null;
            ids_filter?: IdsFilter;
            embedding_strategy?: EmbeddingStrategy;
        };
    };
};
